import { render } from "./TransitionX.vue?vue&type=template&id=7d6cd1a4"
const script = {}

import "./TransitionX.vue?vue&type=style&index=0&id=7d6cd1a4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__